/**
 * @author: leroy
 * @date: 2021/11/18 14:32
 * @description：monitor
 */
import { makeAutoObservable } from 'mobx';
import { enableStaticRendering } from 'mobx-react';
import { postByte, postFrame, postPertinent } from '@/store/services/monitor';

enableStaticRendering(typeof window === 'undefined');

type Data = {
  firstPicture: string | undefined;
  microphoneId: string | undefined;
  mobileDeviceStatus: boolean | undefined | 'pc' | 'wechatOut';
  signature: Blob | null;
  frames: API.Monitor.Frame[];
  pertinents: API.Monitor.Pertinent[];
  bytes: API.Monitor.Byte[];
  offlineImages: Record<string, Blob>;
};

export class MonitorStore {
  // 数据
  data: Data = {
    // 学生校验首图
    firstPicture: '',
    // 麦克风流ID 用做判断是否开启
    microphoneId: '',
    // 手机设备调试状态
    mobileDeviceStatus: undefined,
    // 签名
    signature: null,
    // 帧
    frames: [],
    // 切题时刻
    pertinents: [],
    // 字节回放
    bytes: [],
    // 断网下图片
    offlineImages: {},
  };

  // 服务端数据
  hydrate = (data) => {
    if (!data) return;
    Object.entries(data).forEach(([key, value]) => {
      this[key] = value;
    });
  };

  saveData = (data: Partial<Data>) => {
    Object.entries(data).forEach(([key, value]) => {
      this.data[key] = value;
    });
  };

  saveFrame = async (data: Data['frames'][number]) => {
    let index = this.data.frames.findIndex((ele) => ele.trigger_time === data.trigger_time);
    if (index < 0) {
      index = this.data.frames.length;
      this.data.frames.push(data);
    }
    try {
      const res = await postFrame(data);
      if (res.status === 'success') {
        console.log('上传成功');
        this.data.frames[index].isSuccess = true;
        return;
      }
      console.log('上传失败', res.message);
    } catch (e) {
      console.log('上传失败', e);
      throw new Error('上传失败');
    }
  };

  savePertinent = async (data: Data['pertinents'][number]) => {
    let index = this.data.pertinents.findIndex((ele) => ele.time === data.time);
    if (index < 0) {
      index = this.data.pertinents.length;
      this.data.pertinents.push(data);
    }
    try {
      const res = await postPertinent(data);
      if (res.status === 'success') {
        console.log('上传成功');
        this.data.pertinents[index].isSuccess = true;
        return;
      }
      console.log('上传失败', res.message);
    } catch (e) {
      console.log('上传失败', e);
    }
  };

  saveByte = async (data: Data['bytes'][number]) => {
    let index = this.data.bytes.findIndex((ele) => ele.time === data.time);
    if (index < 0) {
      index = this.data.bytes.length;
      this.data.bytes.push(data);
    }

    try {
      const res = await postByte(data);
      if (res.status === 'success') {
        console.log('上传成功');
        // 获取对应数据下标
        this.data.bytes[index].isSuccess = true;
        return;
      }
      console.log('上传失败', res.message);
    } catch (e) {
      console.log('上传失败', e);
    }
  };

  saveOfflineImage = async (url: string, file: Blob) => {
    this.data.offlineImages[url] = file;
  };
  deleteOfflineImage = async (url: string) => {
    delete this.data.offlineImages[url];
  };

  constructor() {
    makeAutoObservable(this);
    // makeLoggable(this);
  }
}

export type MonitorState = Partial<Data>;
